import { PartialDate } from 'common/api/PartialDate';
import { PartialDatePrecision } from 'common/api/PartialDateType';
import formatDate from 'common/tools/date/format';

export function formatSocialMediaImageEndDate(
  iso: string | null | undefined
): string | null {
  if (!iso) return null;
  const trimmed = iso.trim();
  if (!trimmed) return null;
  const pd = new PartialDate(trimmed, PartialDatePrecision.DAY);
  if (Number.isNaN(pd.date.getTime())) return null;
  const end = pd.date;
  const now = new Date();
  const isCurrentMonth =
    end.getFullYear() === now.getFullYear() &&
    end.getMonth() === now.getMonth();
  if (isCurrentMonth) {
    return formatDate(end, {
      day: '2-digit',
      month: '2-digit'
    });
  }
  return formatDate(end, {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  });
}
